class Insured {
    constructor(id, firstName, lastName, email, birthday, age, phoneType, phone) {
        this.id = id
        this.firstName = firstName
        this.lastName = lastName
        this.name = `${firstName} ${lastName}`
        this.email = email
        this.birthday = birthday
        this.age = age
        this.phoneType = phoneType
        this.phone = phone
    }

    getFullName() {
        return `${this.firstName} ${this.lastName}`
    }

    static fromJson({ id, name, lastName, email, birthday, age, phoneType, phoneNumber }) {
        return new Insured(id, name, lastName, email, birthday, age, phoneType, phoneNumber)
    }
}

export default Insured
